var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-poster-viewer"},[_c('v-img',{attrs:{"src":_vm.src,"contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }